import { render, staticRenderFns } from "./FarmAnalysis.vue?vue&type=template&id=748bc52a&"
import script from "./FarmAnalysis.vue?vue&type=script&lang=js&"
export * from "./FarmAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports